import React from 'react';

import { StyleVariant, Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';

type TeamLogoFallbackTextProps = {
    height: number;
    teamName?: string;
    textColor: string;
    variant?: StyleVariant;
    showFullTeamName?: boolean;
    fontSize?: number;
};

export const TeamLogoFallbackText = ({
    height,
    teamName,
    textColor,
    variant = 'teamLogoFallback',
    showFullTeamName = false,
    fontSize,
}: TeamLogoFallbackTextProps) => {
    const firstLetter = teamName?.charAt(0);

    return (
        <Text
            textAlign="center"
            fontFamily={'Oswald-SemiBold'}
            variant={variant}
            lineHeight={height}
            style={[{ color: textColor || ds.colorValue.text.primary }, showFullTeamName ? { fontSize } : null]}
        >
            {showFullTeamName ? teamName : firstLetter}
        </Text>
    );
};
